/**
 * URL sanitization utilities for workflow export.
 * Strips secret query parameters and API keys from URLs to prevent leakage.
 */

/** Try parsing a URL, falling back to prepending https:// for hostless strings */
export const tryParseUrl = (urlString: string): URL | null => {
  try {
    return new URL(urlString);
  } catch {
    try {
      return new URL('https://' + urlString);
    } catch { return null; }
  }
};

/** Strip ?key= query param from URL strings to avoid leaking secrets embedded in URLs */
export const stripUrlQueryKey = (urlString: string): string => {
  const u = tryParseUrl(urlString);
  if (u && u.searchParams.has('key')) {
    u.searchParams.delete('key');
    const result = u.toString();
    // If we added the https:// prefix, strip it back off
    if (!urlString.startsWith('http://') && !urlString.startsWith('https://') && result.startsWith('https://')) {
      return result.slice('https://'.length);
    }
    return result;
  }
  return urlString;
};

/** Extract ?key= value from URL string (for legacy URLs with embedded keys) */
export const extractUrlQueryKey = (urlString: string): string | null => {
  const u = tryParseUrl(urlString);
  return u ? u.searchParams.get('key') : null;
};
